export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12201.3766dac4.jpg";